import candlelightData from './candlelightData'; 
import { useCart } from '../Cart/Cart'; 
import { useState , useEffect } from 'react';
import SubCardDetail from '../Occasions/SubCardDetail';
import './Candlelight.css';
import { toast } from 'react-toastify';

function Candlelight() {

  const [selectedBooking, setSelectedBooking] = useState(null);

  const { addToCart } = useCart();

  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  if (selectedBooking){
  return(
    <SubCardDetail
    card={selectedBooking}
    onBack={() => setSelectedBooking(null)}
    />
  )
}

  const renderStars = (rating) => {
    const fullStars = '⭐'.repeat(rating);
    const emptyStars = '☆'.repeat(5 - rating);
    return fullStars + emptyStars;
  };

  return (
    <div>
      <h2 className="title">Candlelight Experiences</h2>
      <div className="card-container">

        {candlelightData.map((item, idx) => (
         <div 
  className="card" 
  key={idx}
  onClick={() => setSelectedBooking(item)}
  style={{ cursor: "pointer" }}
>
  <img src={item.image} alt={item.title} />
  <div className="card-content">
    <p className="card-title">{item.title}</p>
    <p className="price">₹{item.price.toLocaleString()}</p>
    <div className="stars">{renderStars(item.rating)}</div>
    <button
      className="add-to-cart-btn"
      onClick={(e) => {
        e.stopPropagation(); 
        addToCart({ ...item, quantity: 1 });
        toast.success('Item added to your cart!');
        
      }}
    >
      Add to Cart
    </button>
  </div>
</div>
        ))}
      </div>
 <p className="description">
        Celebrations are the essence of life. Happy!Hub would like to join you in your celebrations by presenting you an unbelievable range of Party Decorations in Hyderabad, Theme decors, Party entertainers, Party planners, Eateries like Popcorn stall, Ice Gola, Party Essentials and many more. The 10 most popular PartyOne birthday party theme decorations are Disney Mickey Mouse, Chhota Bheem, Disney Cars & Spiderman for Boys, Disney Minnie Mouse, Barbie, Crown & Disney Princess for Girls and The Jungle theme & The Smiley theme for both boys and girls as neutral themes. Birthday parties have evolved leaps and bounds with Entertainment playing a pivotal role in the party planning process .The most popular party artists who are always in demand at PartyOne for your party planning are the Magicians, Tattoo artists, Caricature artists, Puppet show artists, Mascots, Balloon modelling, Game show hosts, Face Painting, Theme decorators, Party organisers & Event Managers. PartyOne has its signature ready-to-go PartyOne combo birthday packages for all age groups. PartyOne is truly an online site that has something for every celebration.
      </p>

      <div className="stats-container">
        <div className="stat-card">
          <img src="/Assets/images.png" alt="Ribbon Icon" className="stat-icon" />
          <h3>Served<br />5 Lakh</h3>
          <p>Happy Customers<br />Since 2012</p>
        </div>
        <div className="stat-card">
          <img src="/Assets/download.png" alt="Google Icon" className="google-logo" />
          <h3><span className="star">⭐</span> 4.6/5</h3>
          <p>1342+ reviews on Google</p>  
        </div>
      </div>    </div>
  );
}

export default Candlelight;
